import { ComponentProps } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'

import { useStep } from './provider'

export const NextBtn = (props: ComponentProps<typeof Button>) => {
	const { t } = useLingui()
	const { goToNextStep, canNext } = useStep()

	return (
		<Button
			size='sm'
			type='button'
			className='flex-1'
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				goToNextStep()
			}}
			disabled={!canNext()}
			{...props}
		>
			{t`Continuer`}
		</Button>
	)
}
